import * as types from "../../types/dashboard/dashboard";

const INITIAL_STATE = {
  dashboard: {},
  plans: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.DASHBOARD_DATA_RECEIVE:
      return { ...state, dashboard: action.payload };
    case types.DASHBOARD_PLANS_RECEIVE:
      return { ...state, plans: action.payload };
    default:
      return state;
  }
};
